import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]
  static values = { shouldSubmit: Boolean }

  connect() {
    if (this.shouldSubmitValue) {
      // Add a brief delay so users see the verification message, then auto-submit
      setTimeout(() => {
        this.formTarget.submit()
      }, 1500) // 1.5 second delay
    }
  }
}